import { render, staticRenderFns } from "./ListUserBusiness.vue?vue&type=template&id=404b2241&scoped=true&lang=pug&"
import script from "./ListUserBusiness.vue?vue&type=script&lang=js&"
export * from "./ListUserBusiness.vue?vue&type=script&lang=js&"
import style0 from "./ListUserBusiness.vue?vue&type=style&index=0&id=404b2241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404b2241",
  null
  
)

export default component.exports